export type SearchErrorCases = {
    empty: ErrorCase
    invalidYear: ErrorCase
}

export type ErrorTypeCases = { [errorName: string]: ErrorCase }

const errorTypes: SearchErrorCases = {
    empty: {
        message: 'Error: Search is empty, please provide either a School Name or C3 ID or an Academic Year.',
        errorType: 'empty'
    },
    invalidYear: {
        message: 'Error: Search by Academic Year requires a four digit number, eg 2021',
        errorType: 'invalidYear'
    }
};

export type ErrorCase = {
    message: string
    errorType: keyof SearchErrorCases
}

export function validateSearchForm (current: any) {
    const errors: ErrorTypeCases = {};
    const hasSearchTerm = typeof current?.term === 'string';
    const hasSearchAcademicYear = typeof current?.academicYear === 'number' && current?.academicYear !== 0;

    if (!hasSearchTerm && !hasSearchAcademicYear) {
        errors.empty = errorTypes.empty;
    }

    if (hasSearchAcademicYear && `${current?.academicYear}`.length !== 4) {
        errors.invalidYear = errorTypes.invalidYear;
    }

    return errors;
}
